/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateUnitBrandData} from '../api'

export const useMutationUpdateUnitBrandData = createReactQueryMutationHook('updateUnitBrandData', updateUnitBrandData)
